import { motion } from "framer-motion";

const EASE = [0.2, 0.8, 0.2, 1];

export const MaskLines = ({ lines, className = "", lineClassName = "", lastClassName = "", delay = 0.1, as = "h1", testId }) => {
  const Tag = motion[as];
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName} ${i === lines.length - 1 ? lastClassName : ""}`}
            initial={{ y: "105%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, y = 28, as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const SectionHead = ({ eyebrow, title, className = "", titleClass = "", testId }) => (
  <FadeUp className={className}>
    {eyebrow && <span className="eyebrow">{eyebrow}</span>}
    <h2 data-testid={testId} className={`mt-5 text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-[var(--ink)] ${titleClass}`}>
      {title}
    </h2>
  </FadeUp>
);
